"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OR = exports.OR = "or";
var AND = exports.AND = "and";
var NOT = exports.NOT = "not";